// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"138":"e495e0bd","938":"33e5c8cc","979":"b7d5be4b"}[chunkId] + ".css";
};